import { useQueries } from '@tanstack/react-query'
import { Table } from 'components/table'
import { ICount } from 'components/table/table-wrapper'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import { ICustomerPermissionDTO } from 'data/dtos/operation/i-customer-permission-dto'
import React, { ChangeEvent, MouseEvent, useState } from 'react'
import api from 'services/api'
import { loadCount, loadList } from 'services/requests'
import { useStyles } from './styles'

const headCells: ITableHeadDTO[] = [
  {
    id: 'keyPermission',
    label: 'Chave da Permissão',
    width: 3,
    type: 'text',
  },
  {
    id: 'tradingName',
    label: 'Seller',
    width: 3,
    type: 'text',
  },
  {
    id: 'tradingName',
    label: 'Buyer',
    width: 3,
    type: 'text',
  },
  {
    id: 'isPermitted',
    label: 'É permitido',
    width: 1,
    type: 'text',
  },
]

const CustomerPermissionList: React.FC = () => {
  const [page, setPage] = useState<number>(0)
  const [search, setSearch] = useState<string>('')
  const [rowsPerPage, setRowsPerPage] = useState<number>(100)
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])

  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')

  const classes = useStyles()

  const [list, count] = useQueries({
    queries: [
      {
        queryKey: ['customers', 'list', search, page, rowsPerPage, columnOrder],
        queryFn: () => loadList('/customer-permissions/list', { search, page, rowsPerPage, columnOrder, organizationId: '' }),
        initialData: { data: { data: [] } } as any,
      },
      {
        queryKey: ['customers', 'count', search],
        queryFn: () => loadCount('/customer-permissions/count', search),
        initialData: { data: { data: { count: 0 } } } as any,
      },
    ],
  })

  if (list.isError || count.isError) {
    return <div>Error...</div>
  }

  const listData = list.data?.data.data as ICustomerPermissionDTO[]
  const countData = count.data?.data.data as ICount

  const handleDelete = async () => {
    await api
      .delete(`/customer-permissions/${recordToDelete}`)
      .then(async () => await Promise.all([list.refetch(), count.refetch()]))
      .catch((error) => console.log(error.response?.data))
  }

  const searchChange = (value: string) => setSearch(value)

  const handleClose = () => setModalIsOpen(false)

  const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    event!.preventDefault()
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleCloseDelete = () => {
    setModalIsOpen(false)
    handleDelete()
  }

  const handleDeleteButton = (e: MouseEvent<any, any>, id: string) => {
    e.stopPropagation()
    setModalIsOpen(true)
    setRecordToDelete(id)
  }

  const handleSortChange = (index: number) => {
    columnOrder[index] = columnOrder[index] === 'ASC' ? 'DESC' : 'ASC'

    setColumnOrder(columnOrder)
  }

  const tabOptions = [
    {
      title: 'Todas',
      size: countData.count,
      handleClick: () => {},
    },
  ]

  return (
    <Table.Root>
      <Table.Info
        title='Permissões de Clientes'
        route='/customer-permissions/new'
        subTitle='Dados coletados sobre as permissões entre seller e buyer.'
      />

      <Table.tabs options={tabOptions} />
      <Table.SearchBar
        value={search}
        handleChange={searchChange}
      />

      <Table.Overlay
        isEmpty={listData.length <= 0}
        isSearch={search.length > 0}
        isLoading={count.isPending || list.isPending}
        route='/customer-permissions/new'
        emptyRouteText='Adicionar customer_permission'
        searchRouteText='Adicionar customer_permission'
        searchMessage='Nenhum customer_permission encontrado, você pode criar um novo customer_permission clicando no botão'
        emptyMessage='Seja bem-vindo à página de gerenciamento de CustomerPermissionss. Até o momento, nenhum customer_permission foi criado. Para começar, você pode criar um novo customer_permission clicando no botão'
      >
        <Table.Wrapper
          totalRows={countData.count}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          page={page}
          handleClose={handleClose}
          handleCloseDelete={handleCloseDelete}
          modalIsOpen={modalIsOpen}
        >
          <Table.Header
            handleSortChange={handleSortChange}
            setOrder={setColumnOrder}
            headCells={headCells}
            order={columnOrder}
          />
          <Table.Body
            handleDeleteButton={handleDeleteButton}
            editRoutePath='/customer-permissions/edit'
            headCells={headCells}
            rows={listData}
          />
        </Table.Wrapper>
      </Table.Overlay>
    </Table.Root>
  )
}

export default CustomerPermissionList
